import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import Tab from "../Tab";
import styles from "./SelectionsHeader.module.scss";
import FilterIcon from "../../../../assets/icons/filter_icon.svg";
import HeartIcon from "../../../../assets/icons/heart_icon.svg";
import StatsIcon from "../../../../assets/icons/stats-graph_icon.svg";
import SortByIcon from "../../../../assets/icons/sortByIcon.svg";
import {
  ADD_FAVOURITES_VIEW,
  COMBINED_FILTERS_VIEW,
  MY_FAVOURITES_VIEW,
  SORT_BY_VIEW,
  SortByNameMap,
  STATS_VIEW,
  StatsDropdownOptionsMap,
  WARNING_VIEW,
} from "../../../../constants";
import {
  SELECT_FAVOURITE,
  SET_ACTIVE_FILTER_VIEW,
  SET_ACTIVE_VIEW,
  SET_WARNING,
} from "../../../../constants/actions";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import { countActiveFilters } from "../../../../lib/filters";
import { ScrollableFavourites } from "../ScrollableFavourites";
import ToolTip from "../../../../components/OnboardingPopup/components/ToolTip";
import {
  FAVOURITES,
  FILTERS,
  FILTERS_TYPE,
  OPEN,
  SORT_BY_FILTER_TYPE,
  ALL,
  STATS_FILTER_TYPE,
} from "../../../../constants/analytics";

export default function SelectionsHeader({ children, location }) {
  const { loggedIn } = useSelector((state) => state.view);
  const { filters, storedFavourites, onboardingStep } = useSelector(
    (state) => state.filter
  );
  const dispatch = useDispatch();
  const { stats, sortBy } = filters;
  const statsLabel = StatsDropdownOptionsMap.get(stats);
  const sortByLabel = SortByNameMap.get(sortBy);
  const selectionsHeaderClass = clsx(styles.selectionsHeader, {
    [styles.selectionsHeaderBetShuffle]: location === "betShuffle",
  });
  const selectionsHeaderFilterButton = clsx(styles.selectionsHeaderButton, {
    [styles.selectionsHeaderButtonHighlighted]: onboardingStep === 2,
  });
  // Count active filters
  const numberOfActiveFilters = countActiveFilters(filters);

  const handleFilterClick = () => {
    dispatch({
      type: SET_ACTIVE_FILTER_VIEW,
      payload: COMBINED_FILTERS_VIEW,
    });

    sendAnalyticsEvent({
      event: FILTERS,
      type: FILTERS_TYPE,
      action: OPEN,
    });
  };

  const handleStatsClick = () => {
    dispatch({
      type: SET_ACTIVE_FILTER_VIEW,
      payload: STATS_VIEW,
    });

    sendAnalyticsEvent({
      event: FILTERS,
      type: STATS_FILTER_TYPE,
      action: OPEN,
    });
  };

  const handleSortByClick = () => {
    dispatch({
      type: SET_ACTIVE_FILTER_VIEW,
      payload: SORT_BY_VIEW,
    });

    sendAnalyticsEvent({
      event: FILTERS,
      type: SORT_BY_FILTER_TYPE,
      action: OPEN,
    });
  };

  const handleAddFavouritesClick = () => {
    if (!loggedIn) {
      dispatch({ type: SET_WARNING, payload: "LOGIN" });
      dispatch({
        type: SET_ACTIVE_VIEW,
        payload: WARNING_VIEW,
      });
      return;
    }

    dispatch({
      type: SET_ACTIVE_VIEW,
      payload: ADD_FAVOURITES_VIEW,
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: ALL,
      action: OPEN,
    });
  };

  const handleUpdateFavouritesClick = () => {
    dispatch({
      type: SELECT_FAVOURITE,
      payload: "",
    });

    dispatch({
      type: SET_ACTIVE_VIEW,
      payload: MY_FAVOURITES_VIEW,
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: ALL,
      action: OPEN,
    });
  };

  function renderFavouritesButton() {
    if (storedFavourites?.length > 0) {
      return (
        <button
          type="button"
          className={styles.selectionsHeaderButton}
          onClick={handleUpdateFavouritesClick}
        >
          <img src={HeartIcon} alt="Favourites" />
          <span>My Favourites</span>
        </button>
      );
    }

    return (
      <button
        type="button"
        className={styles.selectionsHeaderButton}
        onClick={handleAddFavouritesClick}
      >
        <img src={HeartIcon} alt="Favourites" />
        <span>Add Favourites</span>
      </button>
    );
  }

  return (
    <div className={selectionsHeaderClass}>
      {location !== "betShuffle" && <h2>Selections</h2>}
      <div className={styles.selectionsHeaderButtons}>
        <div className={styles.selectionsHeaderButtonsStatic}>
          {onboardingStep === 2 ? <ToolTip /> : null}
          <button
            type="button"
            onClick={handleFilterClick}
            className={selectionsHeaderFilterButton}
          >
            <img src={FilterIcon} alt="Filter" />
            <span className={styles.filterLabel}>Filters</span>
            {numberOfActiveFilters > 0 && (
              <span className={styles.filterCount}>
                {numberOfActiveFilters}
              </span>
            )}
          </button>
          <hr className={styles.selectionsHeaderDivider} />
          {renderFavouritesButton()}
        </div>
        {storedFavourites?.length > 0 && (
          <ScrollableFavourites favourites={storedFavourites} />
        )}
      </div>
      <div className={styles.selectionsContainer}>
        {onboardingStep === 1 || onboardingStep === 6 ? <ToolTip /> : null}
        {location !== "betShuffle" && (
          <div className={styles.selectionsHeaderTabs}>
            <Tab onClick={handleStatsClick} highlighted={onboardingStep === 1}>
              <img src={StatsIcon} alt="Stats" />
              <span>{statsLabel}</span>
            </Tab>
            <hr className={styles.selectionsTabDivider} />
            <Tab onClick={handleSortByClick} highlighted={onboardingStep === 6}>
              <img src={SortByIcon} alt="Sort By" />
              <span>{sortByLabel}</span>
            </Tab>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
